<template>
  <div class="p-3 flex flex-col gap-5 mt-5 bg-white rounded-md">
    <div class="p-3 shadow-md rounded-lg">
      <div class="header grid grid-cols-12 gap-2 font-semibold border-b border-grey-001">
        <span class="p-2 col-span-3 self-center">
          {{ title }}
        </span>
        <div
          v-for="(key) in Object.keys(headers)"
          :key="key"
          class="p-2"
          :class="{
            'col-span-4': headers[key].hasOwnProperty('key') && headers[key]['key'] === 'ytd',
            'col-span-2': headers[key].hasOwnProperty('key') && headers[key]['key'] === 'mtd',
            'text-center self-end': !headers[key].hasOwnProperty('title')
          }"
        >
          <div
            v-if="headers[key].hasOwnProperty('title')"
            class="flex flex-col items-center justify-between w-full h-full"
          >
            <span class="text-center">
              {{ headers[key]['title'] }}
            </span>
            <div class="w-full flex flex-row items-end justify-evenly">
              <span
                v-for="(item) in headers[key]['value']"
                :key="item"
              >
                {{ item }}
              </span>
            </div>
          </div>
          <span
            v-else
          >
            {{ headers[key] }}
          </span>
        </div>
      </div>

      <!--  FIRST ROW  -->
      <div class="grid grid-cols-12 gap-2 items-center border-b border-grey-001">
        <span class="p-2 col-span-3">
          {{ firstRow.title }}
        </span>
        <div class="text-center">
          {{ handleValidateAndFormatNumber(firstRow.data.previous_year) }}
        </div>
        <div class="text-center">
          {{ handleValidateAndFormatNumber(firstRow.data.current_year) }}
        </div>
        <div class="h-full flex items-center justify-center">
          <div
            class="ytd-container"
            :style="{
              background: firstRowYtd.color
            }"
          >
            <span class="text-white"> 
              {{
                handleValidateAndFormatNumber(
                  firstRow.data.current_year_actual,
                  firstRow.data.current_year_actual > 999999 ? 0 : 2
                )
              }}
            </span>
            <span
              class="ytd-item"
              :class="firstRowYtd.class"
            >
              <vs-icon
                :icon="firstRowYtd.icon"
                :color="firstRowYtd.color"
                size="small"
              />
              <span>{{ handleValidateAndFormatNumber(firstRow.data.current_year_percentage) }}%</span>
            </span>
          </div>
        </div>
        <div class="col-span-4">
          <slot name="first-ytd-chart" />
        </div>
        <div class="col-span-2">
          <slot name="first-mtd-chart" />
        </div>
      </div>

      <!--  SECOND ROW  -->
      <div
        v-if="!hideRow.includes(secondRow.title)"
        class="grid grid-cols-12 gap-2 items-center border-b border-grey-001"
      >
        <span class="p-2 col-span-3">
          {{ secondRow.title }}
        </span>
        <div class="text-center">
          {{ handleValidateAndFormatNumber(secondRow.data.previous_year) }}
        </div>
        <div class="text-center">
          {{ handleValidateAndFormatNumber(secondRow.data.current_year) }}
        </div>
        <div class="h-full flex items-center justify-center">
          <div
            class="ytd-container"
            :style="{
              background: secondRowYtd.color
            }"
          >
            <span class="text-white">
              {{
                handleValidateAndFormatNumber(
                  secondRow.data.current_year_actual,
                  secondRow.data.current_year_actual > 999999 ? 0 : 2
                )
              }}
            </span>
            <span
              class="ytd-item"
              :class="secondRowYtd.class"
            >
              <vs-icon
                :icon="secondRowYtd.icon"
                :color="secondRowYtd.color"
                size="small"
              />
              <span>{{ handleValidateAndFormatNumber(secondRow.data.current_year_percentage) }}%</span>
            </span>
          </div>
        </div>
        <div class="col-span-4">
          <slot name="second-ytd-chart" />
        </div>
        <div class="col-span-2">
          <slot name="second-mtd-chart" />
        </div>
      </div>
    </div>
    <div
      v-if="isExpanded"
      class="w-full flex flex-row items-center justify-between"
    >
      <slot name="average-pie-chart" />
      <slot name="rank-bar-chart" />
    </div>
    <div class="w-full">
      <vs-button
        type="filled"
        color="primary"
        class="w-full"
        @click="handleSeeDetails"
      >
        {{
          isExpanded
            ? 'See Less'
            : 'View More'
        }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import {handleValidateAndFormatNumber} from "@/utils/inputFormatter";

export default {
  name: 'KpiTrackingDetails',
  props: {
    type: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    headers: {
      type: Object,
      default: () => {}
    },
    firstRow: {
      type: Object,
      default: () => {}
    },
    secondRow: {
      type: Object,
      default: () => {}
    },
    firstRowYtd: {
      type: Object,
      default: () => {}
    },
    secondRowYtd: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isExpanded: false,
      hideRow: ['% Schedule Volume for the week VS Actual Volume']
    }
  },
  methods: {
    handleValidateAndFormatNumber,
    handleSeeDetails() {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.$nextTick(() => {
          this.$emit('see-detail')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ytd-container {
  @apply w-full h-full p-4 flex flex-col items-center justify-center gap-5;

  .ytd-item {
    @apply px-1 flex flex-row items-center gap-1 bg-white rounded-md;

    &.red {
      color: #FF3662;
    }

    &.green {
      color: #33B57D;
    }
  }
}
</style>